function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.55556 3.75H15.4444C15.8858 3.75 16.25 4.11421 16.25 4.55556V15.4444C16.25 15.8858 15.8858 16.25 15.4444 16.25H4.55556C4.10888 16.25 3.75 15.8882 3.75 15.4444V4.55556C3.75 4.11421 4.11421 3.75 4.55556 3.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 11H8V12C8 13.1046 8.89543 14 10 14V14C11.1046 14 12 13.1046 12 12V11H16",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/inbox.72d58481.svg";
export { SvgComponent as ReactComponent };